import React from 'react';
import './Entercode.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import logolight from '../../images/urology-logo-white.svg';
import keyicon from '../../images/key.svg';
import { Link } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";

function EntercodeComponent() {
    return (
      <>
        <section className='entercode-blk-main'>
            <div className='entercode-bg-blk'>
                <div className='logo-top'>
                    <img src={logolight} alt='logo'></img>
                </div>
            </div>
            <div className='entercode-text-blk d-flex align-items-center'>
                <div className='entercode-content'>
                    <div className='keyicon'>
                        <img src={keyicon} alt='key'></img>
                    </div>
                    <div className='entercode-main-text'>
                        <h2>Enter Code</h2>
                        <p>Verification Code Sent on ex****12@gmail.com</p>
                        <div className='code-blk d-flex gap-3'>
                            <Form.Control type="text"/>
                            <Form.Control type="text"/>
                            <Form.Control type="text"/>
                            <Form.Control type="text"/>
                        </div>
                        <Button variant="primary" className='dark-btn reset-btn'>Verify</Button>
                        <p>Did not receive code? <span>Resend Code</span></p>
                    </div>
                    <Link to="/signin" className='backto-blk'><FaArrowLeftLong/>Back to log in</Link>
                </div>
            </div>
        </section>
      </>
    );
}
    
export default EntercodeComponent;